import { CompanySelector } from './CompanySelector';
import { useCompany } from '../../contexts/CompanyContext';

export default function CompanyTopBar() {
  const { selectedCompanies, addCompany, removeCompany } = useCompany();

  return (
    <div className="flex items-center gap-2 px-4 py-2 border-b border-zinc-200 bg-white min-h-[40px] flex-shrink-0">
      <span className="text-[10px] font-medium text-zinc-400 uppercase tracking-wide flex-shrink-0">Companies</span>
      <CompanySelector
        selected={selectedCompanies}
        onSelect={addCompany}
        onRemove={removeCompany}
        multiSelect
        direction="down"
        trigger="pill"
      />
    </div>
  );
}
